'use strict';
import request from '@/utils/request';
class CommentsprojectService{
    static list(query){
        return request({
            url:'/comments/getcomments',
            method:'get',
            params:query
        })
    }
}

export default CommentsprojectService
